import { render, staticRenderFns } from "./MDetailPrice2.vue?vue&type=template&id=7f884792&scoped=true"
import script from "./MDetailPrice2.vue?vue&type=script&lang=js"
export * from "./MDetailPrice2.vue?vue&type=script&lang=js"
import style0 from "./MDetailPrice2.vue?vue&type=style&index=0&id=7f884792&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f884792",
  null
  
)

export default component.exports